import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import QuickbetLobbyComponent from "../Components/QuickbetLobbyComponent";

interface QBLProps {
    atagParams: string | null,
    viewType?: string | null
    sourceParams: string | null,
    ticketOpenMode: string | null,
}
const QuickbetLobby: FC <QBLProps> = ({atagParams, viewType, sourceParams, ticketOpenMode}) => {
    const {getQuickbetsData} = useAction();
    const {quickbetsData} = useTypedSelector((state) => state.quickbetsReducer);
    useEffect(()=>{
        getQuickbetsData();
    }, [])
    return (
        <>
            {
                quickbetsData.length > 0 ?
                    <QuickbetLobbyComponent
                        data={quickbetsData}
                        sourceParams={sourceParams}
                        atagParams={atagParams}
                        viewType={viewType}
                        ticketOpenMode={ticketOpenMode}
                    />
                    : null
            }
        </>
    );

}

export default QuickbetLobby;
